<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12pWm9/tc-custom/9781631597251.jpg?1724535973231" alt="This image is the cover for the book Ultimate Soap Carving"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ultimate Soap Carving
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Learn to carve adorable creations out of soap, from cakes and doughnuts to high-top sneakers and unicorns.</b><br/><br/> In <i>Ultimate Soap Carving,</i> Makiko Sone, founder of the Mizutama.Soap YouTube channel, shares her secrets for designing and hand carving a variety of beautiful soap designs by cutting, shredding, shaping, sculpting, and other oddly satisfying techniques that fans of ASMR (Autonomous Sensory Meridian Response) will love.<br/><br/> Packed with guidance and inspiration, <i>Ultimate Soap Carving</i> will teach you everything you need to carve your own stunning soap designs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Makiko Sone
      </h2>
      
      <p class="authorDescription body article">Makiko Sone, better known to her followers as Mizutama Soap, demonstrates cute, fantastic, and easy to make soap carving projects on her YouTube channel, mizutama.soap, and sells supplies on her Etsy shop, MizutamaStudio. Her most popular video has received over one million views. She lives in Japan outside of Tokyo.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Quarry Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dec69b0e